import Axios from "axios";
import {
    SET_SIDEBAR_COLLAPSE,
    UNSET_SIDEBAR_COLLAPSE
  } from "@/store/mutation-types";

// import { saveMenuSetup, getMenuList, deleteMenu  } from "@/store/api";
// initial state
const state = {
  sidebar_status: true,
};

const getters = {
  getSidebarCollapse(state) {
    return state.sidebar_status;
  },
};
const mutations = {
  [SET_SIDEBAR_COLLAPSE](state) {
    state.sidebar_status = true;
  },
  [UNSET_SIDEBAR_COLLAPSE](state) {
    state.sidebar_status = false;
  },

};

const actions = {

//   saveMenuSetup({ commit }, data) {
//     commit("SET_LOADING", {color: "primary"});
//     return new Promise((resolve, reject) => {
//       Axios.post(saveMenuSetup, data)
//         .then(function (response) {
//           resolve(response);
//         })
//         .catch(function (error) {

//           reject(error);
//         })
//         .then((always) => {
//             commit("UNSET_LOADING");
//         });
//     });
//   },

//   getMenuList({ commit }, data) {
//     return new Promise((resolve, reject) => {
//       Axios.post(getMenuList, data)
//         .then(function (response) {
//           commit('SET_MENU_LIST',response.data.data)
//           resolve(response);
//         })
//         .catch(function (error) {
//           commit('UNSET_MENU_LIST')
//           reject(error);
//         })
//         .then((always) => {
//         });
//     });
//   },




};

export default {
  state,
  getters,
  actions,
  mutations,
};
